// src/pages/AlertasPage.js

import React, { useState, useEffect, useCallback } from 'react';

import axios from 'axios';

import { GoogleMap, useJsApiLoader, Marker } from '@react-google-maps/api';

import { 

  Box, Grid, List, ListItem, ListItemButton, ListItemText, Typography, 

  CircularProgress, Alert, Paper

} from '@mui/material';


const containerStyle = {

  width: '100%',

  height: 'calc(100vh - 128px)'

};


const defaultCenter = {

  lat: 21.1290,

  lng: -101.6795

};


const AlertasPage = () => {

  const [alertas, setAlertas] = useState([]);

  const [loading, setLoading] = useState(true);

  const [error, setError] = useState('');

  const [selectedAlert, setSelectedAlert] = useState(null);


  const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:8000';


  const { isLoaded } = useJsApiLoader({

    id: 'google-map-script',

    googleMapsApiKey: process.env.REACT_APP_Maps_API_KEY

  });


  const fetchAlertas = useCallback(async () => {

    setLoading(true);

    try {

      const token = localStorage.getItem('accessToken');

      if (!token) {

        setError("No autenticado.");

        return;

      }

      const response = await axios.get(`${apiUrl}/alertas`, {

        headers: { Authorization: `Bearer ${token}` }

      });

      const alertasConCoords = response.data.filter(a => a.lat != null && a.lon != null);

      setAlertas(alertasConCoords);

    } catch (err) {

      setError('No se pudo conectar para ver las alertas.');

    } finally {

      setLoading(false);

    }

  }, [apiUrl]);


  useEffect(() => {

    if (isLoaded) {

        fetchAlertas();

    }

  }, [isLoaded, fetchAlertas]);


  const handleAlertClick = (alerta) => {

    setSelectedAlert(alerta);

  };


  if (!isLoaded) {

    return <Box sx={{ p: 4 }}><CircularProgress /> <Typography>Cargando mapa...</Typography></Box>;

  }


  return (

    <Grid container spacing={2} sx={{ height: 'calc(100vh - 64px - 48px)' }}>

      <Grid item xs={12} md={4} sx={{ height: '100%'}}>

        <Paper elevation={3} sx={{height: '100%', display: 'flex', flexDirection: 'column'}}>

          <Typography variant="h6" sx={{ p: 2, backgroundColor: 'primary.main', color: 'white' }}>

            Alertas Activas

          </Typography>

          <Box sx={{ flexGrow: 1, overflowY: 'auto' }}>

            {loading && <Box sx={{p: 2, textAlign: 'center'}}><CircularProgress size={24} /></Box>}

            {error && <Alert severity="error">{error}</Alert>}

            <List>

              {!loading && alertas.length > 0 ? (

                alertas.map((alerta) => (

                  <ListItem key={alerta.id} disablePadding>

                    <ListItemButton 

                      onClick={() => handleAlertClick(alerta)}

                      selected={selectedAlert?.id === alerta.id}

                    >

                      <ListItemText 

                        primary={alerta.descripcion}

                        secondary={`Unidad: ${alerta.unidad}`} 

                      />

                    </ListItemButton>

                  </ListItem>

                ))

              ) : (

                !loading && <Typography sx={{ p: 2 }}>No hay alertas nuevas.</Typography>

              )}

            </List>

          </Box>

        </Paper>

      </Grid>


      <Grid item xs={12} md={8} sx={{ height: '100%' }}>

        <GoogleMap

          mapContainerStyle={containerStyle}

          center={selectedAlert ? { lat: selectedAlert.lat, lng: selectedAlert.lon } : defaultCenter}

          zoom={selectedAlert ? 15 : 5}

        >

          {selectedAlert && (

            <Marker 

              position={{ lat: selectedAlert.lat, lng: selectedAlert.lon }}

            />

          )}

        </GoogleMap>

      </Grid>

    </Grid>

  );

};


export default AlertasPage;
